import React from "react";
import WhatShapeAccordion from "./Accordion";
import type { StaticImageData } from "next/image";

type Chip = {
  label: string;
  icon?: any;
};

type Item = {
  id: string;
  image: string | StaticImageData;
  number: string;
  title: string;
  content: React.ReactNode;
  chipRows?: Chip[][];
};

type AccordionProps = {
  items: Item[];
  openId: string | null;
  setOpenId: React.Dispatch<React.SetStateAction<string | null>>;
};

export default function WhatShapeRightPanel({
  items,
  openId,
  setOpenId,
}: AccordionProps) {
  return (
    <div className="w-full 2xl:w-[920px] [@media(min-width:2000px)]:w-[1100px] flex flex-col gap-[30px]">
      <WhatShapeAccordion items={items} openId={openId} setOpenId={setOpenId} />
    </div>
  );
}
